<div class="guest-details">
  @if (ls.operation==operationType.create) {
    <div for="" class="page-title guest-details__page-title">
    {{'reservationDetails'| translate}}</div>
  }
  @if (ls.operation==operationType.edit) {
    <div for="" class="page-title guest-details__page-title">
    {{'ModifiedReservationDetails'| translate }}</div>
  }
  <div class="guest-details__reservation-data content-summary" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderBackgroundColor,
    'color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
    <div style="width: 100%;">
      @if (partyDetails?.specialMeal && partyDetails?.specialMeal.Name) {
        <span class="guest-details__guest-info-text"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
          >{{partyDetails.specialMeal.Name}}
          @if (specialMealAmountInfo >0) {
            <span>-
            {{paymentData.OperationCurrency}}{{specialMealAmountInfo | currencyDecimalFormatter}}</span>
          }</span>
        }
        <span class="guest-details__guest-info-text"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
        {{partyDetails?.partySize}} {{'party' | translate}}</span>
        <span class="guest-details__guest-info-text"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
        <!-- {{partyDetails.reservationTime | date:'MM/dd/yyyy'}}</span> -->
        {{partyDetails.reservationTime | formatSettingsDate: ls.restaurantWidgetSettings$.value.DateFormat}}
      </span>
      <span class="guest-details__guest-info-text"
        [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
      {{partyDetails.reservationTime | localizeDate:'h:mm A'}}</span>
      @if (canShowSeatingType && partyDetails.seatingType && partyDetails.seatingType.name) {
        <span class="guest-details__guest-info-text"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
          >{{partyDetails.seatingType.name}}
          @if (ratePlanAmountInfo >0) {
            <span>-
            {{paymentData.OperationCurrency}}{{ratePlanAmountInfo | currencyDecimalFormatter}}</span>
          }
        </span>
      }
      @if (!(ratePlanAmountInfo >0) && !(specialMealAmountInfo>0) && noShowfee > 0 ) {
        <span class="guest-details__guest-info-text"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
          >{{ 'amount' | translate}}
        {{paymentData.OperationCurrency}}{{noShowfee | currencyDecimalFormatter}}</span>
      }
      @if (isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && (guestDetailsForm?.value?.primaryGuest?.firstName || guestDetailsForm?.value.primaryGuest?.lastName)) {
        <span class="guest-details__guest-info-text detail-content"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        >{{guestDetailsForm.value.primaryGuest.firstName}} {{guestDetailsForm.value.primaryGuest.lastName}}</span>
      }
      @if (isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && guestDetailsForm.value.primaryGuest.phone) {
        <span class="guest-details__guest-info-text detail-content"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        >{{guestDetailsForm.value.primaryGuest.phone}}</span>
      }
      @if (isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && guestDetailsForm.value.primaryGuest.email) {
        <span class="guest-details__guest-info-text detail-content"
          [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
        >{{guestDetailsForm.value.primaryGuest.email}}</span>
      }
    </div>
    @if (!ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions || !isFormValid) {
      <div style="padding: 0 12px;">
        <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
      </div>
    }
    @if (isFormValid && ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions) {
      <div class="guest-details__guest-actions">
        <app-button [buttontype]="editSlotsButton" (valueChange)="goBackToReservation()"></app-button>
        <app-button [buttontype]="editGuestButton" (valueChange)="isFormValid = !isFormValid"></app-button>
      </div>
    }
  </div>
  <div class="guest-details__guest-section" [hidden]="ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && isFormValid">
    <!-- <ng-scrollbar> -->
    <!--Needed -->
    @if (displayMessage) {
      <div class="guest-details__admin-msgs"
        >
        <em class="icon-Info guest-details__info-icon"></em>
        @if (isPreReservationMsgHTML) {
          <span
          [innerHTML]="displayMessage"></span>
        }
        @if (!isPreReservationMsgHTML) {
          <span
          >{{displayMessage}}</span>
        }
      </div>
    }
    <div class="guest-details__guest-data">
      @if (ls.showTimer) {
        <div class="guest-details__remaining-time-indicator" tabindex="0">
          <div class="focused-sub-header"
            [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}">{{ls.minutes}}
            <span class="error-message">{{'mins' | translate}}</span> {{ls.seconds}} <span class="error-message">{{'secs'
          | translate}}</span></div>
          <div class="default-form-field guest-details__time-left-text">{{'leftForBooking' | translate}}</div>
        </div>
      }
      @for (guest of guestData; track trackByGuest(i, guest); let i = $index) {
        <div class="guest-details__guest-info"
          [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
          <div for="" class="section-header guest-details__guest-title">{{guest | translate}}
            @if (ls.operation == operationType.edit && i!=0) {
              <em class="icon-DeleteWidget guest-details__delete-icon"
              (click)="openDeleteConfirmationPopUp(i)"></em>
            }
          </div>
          @if (ls.operation != operationType.edit || (ls.operation == operationType.edit && i == 0)) {
            <div class="rs-pt-15"
              >
              <dynamic-form [config]="guestInfoConfig" #form="dynamicForm">
              </dynamic-form>
            </div>
          }
          @if (ls.operation == operationType.edit && i != 0) {
            <div>
              <dynamic-form [config]="guestInfoConfigSecondary" #form="dynamicForm">
              </dynamic-form>
            </div>
          }
          <!-- <span class="guest-details__data-retention" @if (dataRetentionPolicyExisting) {  (click)="showDataRententionPolicy()">{{'clickhere' | translate}}</span> } -->
        </div>
      }
      @if (noShowfee >0 && !rs.additionalGuestPage) {
        <div style="display: flex;flex-direction: column;" tabindex="0">
          <span class="default-sub-header" style="padding-bottom: 8px;margin-top: 16px;">{{noShowPolicyTitle}}</span>
          <div class="default-form-field mb-0" style="background: #f7f7f7;padding: 15px;border-radius: 4px;width: auto;">
            <span>{{'noShowCancellationFee' | translate}} : {{paymentData.OperationCurrency}}{{noShowfee | currencyDecimalFormatter}}</span>
            <p style="padding-top: 8px;margin-bottom: 0;">{{noShowfeeMessage}}</p>
          </div>
        </div>
      }
      @if ((!partyDetails.specialMeal?.Id && ls?.restaurantWidgetSettings$?.value?.CancellationPolicy && ls?.restaurantWidgetSettings$?.value?.CancellationPolicy != '') || (partyDetails.specialMeal?.Id && partyDetails?.specialMeal?.CancellationPolicy && partyDetails?.specialMeal?.CancellationPolicy != '')) {
        <div style="display: flex;flex-direction: column;"  tabindex="0">
          <span class="default-sub-header" style="padding-bottom: 8px;margin-top: 16px;">{{'cancellationPolicy' | translate}}</span>
          <div class="default-form-field mb-0" style="background: #f7f7f7;padding: 15px;border-radius: 4px;width: auto;">
            <span>{{(!partyDetails.specialMeal?.Id && ls?.restaurantWidgetSettings$?.value?.CancellationPolicy && ls?.restaurantWidgetSettings$?.value?.CancellationPolicy != '') ? ls?.restaurantWidgetSettings$?.value?.CancellationPolicy : partyDetails?.specialMeal?.CancellationPolicy }} </span>
          </div>
        </div>
      }
      @if (activityPayment>0 && !rs.additionalGuestPage && ls.operation==operationType.create) {
        <div style="display: flex;flex-direction: column;"
          tabindex="0">
        <span class="default-sub-header" style="
              padding: 10px;margin-top: 16px;
          ">{{'prePaymentPolicy' | translate}}</span>
          @if (!this.paymentData.TaxAmount) {
<div class="default-form-field mb-0" style="    background: #f7f7f7;
              padding: 15px;
              border-radius: 4px;width: auto;">
              <span>{{'totalAmount' | translate}} : {{paymentData.OperationCurrency}}{{activityPayment}}</span>
              <br>
                @if (depositPayable && depositPayable > 0) {
                  <span class="pt-1 pb-1 font-weight-bolder"> {{'amountToBePaid' | translate}} ({{'Deposit' | translate}}) @if (depositDescription) {
                    <i class="icon-Info" matTooltip="{{ depositDescription }}" matTooltipPosition="above"></i>
                    }: {{paymentData.OperationCurrency}}{{depositPayable | currencyDecimalFormatter}}
                  </span>
                }
          <p class="" style="    padding-top: 8px;
              margin-bottom: 0;">
                  {{paymentMessage}}
                </p>
              </div>
            }
            @if (this.paymentData.TaxAmount) {
              <div class="payment-with-tax-view">
                <div class="payment-tax-view-section default-form-field mb-0">
                  <span>{{'SubTotal' | translate}} :</span>
                  <span>{{paymentData.OperationCurrency}}{{paymentWithoutTax | currencyDecimalFormatter}}</span>
                </div>
                <div class="payment-tax-view-section default-form-field mb-0">
                  <span>{{'taxAmount' | translate}} :</span>
                  <span> {{paymentData.OperationCurrency}}{{this.paymentData.TaxAmount | currencyDecimalFormatter}}</span>
                </div>
                <div class="payment-tax-view-section default-form-field mb-0">
                  <span>{{'serviceCharges' | translate}} :</span>
                  <span> {{paymentData.OperationCurrency}}{{this.serviceCharge | currencyDecimalFormatter}}</span>
                </div>
                <div class="payment-tax-view-section default-form-field mb-0">
                  <span>{{'taxOnserviceCharge' | translate}} :</span>
                  <span> {{paymentData.OperationCurrency}}{{this.taxOnServiceCharge | currencyDecimalFormatter}}</span>
                </div>
                @if (depositPayable && depositPayable > 0) {
                  <div class="payment-tax-view-section default-form-field mb-0">
                    <span>{{'amountToBePaid' | translate}} ({{'Deposit' | translate}}) @if (depositDescription) {
                      <i class="icon-Info" matTooltip="{{ depositDescription }}" matTooltipPosition="above"></i>
                      } :
                    </span>
                    <span> {{paymentData.OperationCurrency}}{{depositPayable | currencyDecimalFormatter}}</span>
                  </div>
                }
                <div class="payment-tax-view-section default-form-field mb-0 mt-1 pt-1 border-top">
                  <span>{{'grandTotal' | translate}} :</span>
                  <span> {{paymentData.OperationCurrency}}{{activityPayment | currencyDecimalFormatter}}</span>
                </div>
          <p class="" style="    padding-top: 8px;
          margin-bottom: 0;    ">
                  {{paymentMessage}}
                </p>
              </div>
            }
          </div>
        }
      </div>
      <div class="guest-details__validation">
        @if (ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions) {
          <div class="guest-details__validation-info" tabindex="0">
            @if (validationMessageList?.length) {
              <span class="guest-details__validation-info__text" [innerHTML]="validationMessageList[0]"></span>
            }
            @if (validationMessageList?.length > 1) {
              <ul class="ps-5">
                @for (validationMessage of validationMessageList | slice : 1; track validationMessage; let i = $index) {
                  <li class="guest-details__validation-info__text" [innerHTML]="validationMessage"></li>
                }
              </ul>
            }
          </div>
        }
        <div>
          @if (ls.restaurantWidgetSettings$.value.DisableCustomTermsAndConditions && showIframe) {
            <app-button
            [buttontype]="nextButton" (valueChange)="enableIframe()"></app-button>
          }
        </div>
      </div>
      <div class="rs-ps-10">
        @if (((rs.additionalGuestPage && (rs.additionalGuestRequired) > guestData.length)|| (ls.operation == operationType.edit && (partyDetails.partySize > guestData.length))) && ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowAdditionalGuestDetails) {
          <app-button
          [buttontype]="additionalGuestBtn" (valueChange)="additionalGuest()"></app-button>
        }
      </div>
      @if (!confirmButton.disbaledproperity || !showIframe) {
        <div class="guest-details__actions">
          <app-button [buttontype]="previousButton" (valueChange)="getSeatSelection()"></app-button>
          <app-button [buttontype]="confirmButton" (valueChange)="reservationConfirm()"></app-button>
        </div>
      }

    <!-- </ng-scrollbar> -->
  </div>
  @if (urlSafe) {
    <div class="guest-details__iframe-view" [hidden]="!(showIframe && isFormValid)">
      <iframe class="responsive-iframe" frameBorder="0" [src]="urlSafe" tabindex="0" [attr.aria-label]="'Payment Details' | translate"></iframe>
      @if (guestDetailsForm.invalid) {
        <div
          class="px-5 position-absolute activity-description-bold payment-protection d-flex flex-column justify-content-center">
          <div class="p-3 d-flex justify-content-center payment-overlay-text align-items-center text-center">
            {{ "enterNecessaryDetailsForPayment" | translate }}
          </div>
        </div>
      }
    </div>
  }
</div>